webpackJsonp([20],{

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_icon_style__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_icon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Views_components_header__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Views_components_foot__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Views_components_mobilefoot__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Views_components_menu__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_icon__["a" /* default */]);
var userUrl = __WEBPACK_IMPORTED_MODULE_4_Constans__["a" /* default */].AllUrl.url.dev;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    myHeader: __WEBPACK_IMPORTED_MODULE_7_Views_components_header__["a" /* default */],
    myFooter: __WEBPACK_IMPORTED_MODULE_8_Views_components_foot__["a" /* default */],
    mobilefoot: __WEBPACK_IMPORTED_MODULE_9_Views_components_mobilefoot__["a" /* default */],
    myMenu: __WEBPACK_IMPORTED_MODULE_10_Views_components_menu__["a" /* default */]
  },
  data: function data() {
    return {
      hotOnlineList: [],
      canonicalUrl: '',
      title: '',
      desc: ''
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{
        vmid: "description",
        name: "description",
        content: this.desc
      }],
      link: [{
        ref: "canonical",
        href: this.canonicalUrl
      }]
    };
  },
  created: function created() {
    var that = this;

    this.fetchData();
    var _arg = __WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getQueryStringArgs();
    var language = __WEBPACK_IMPORTED_MODULE_6_Common_cookie__["a" /* default */].getCookie('language');
    if (__WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getLang() == 'cn' || _arg.lang == 'zh-Hans-TW' || language == '简体中文') {
      that.canonicalUrl = 'https://www.lespark.cn/live.html?lang=zh-Hant-TW';
      that.title = '在线直播互动 - LesPark';
      that.desc = 'LesPark汇集了众多有趣、有颜、有才的女性主播，您可以实时登陆观看热门直播的精彩视频，LesPark可满足您对于观看高颜值直播、视频交友等多种需求。';
    } else if (__WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].getLang() == 'en' || _arg.lang == 'en' || language == 'English') {
      that.canonicalUrl = 'https://www.lespark.cn/live.html?lang=en';
      that.title = 'Lesbian community -  LesPark';
      that.desc = 'LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.';
    } else {
      that.canonicalUrl = 'https://www.lespark.cn/live.html';
      that.title = 'Les&拉拉直播 - 在線直播互動 - LesPark';
      that.desc = 'LesPark匯集了眾多有趣、有顏、有才的女性主播，您可以實時登陸觀看熱門直播的精彩視頻，LesPark可滿足您對於觀看高顏值直播、視頻交友等多種需求。';
    }
  },
  mounted: function mounted() {
    var that = this;
    if (!__WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].isPhantomjs()) {
      that.changeType();
    }
    window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_5_Common_util__["a" /* default */].debounce(that.changeType, 1000));
  },

  methods: {
    goLive: function goLive(id) {
      window.location.href = '/live/' + id + '.html';
    },
    changeType: function changeType() {
      var that = this;
      if (document.documentElement.clientWidth < 960) {
        if (document.getElementsByClassName('mobile')[0]) {
          document.getElementsByClassName('mobile')[0].style.display = 'block';
        }
        if (document.getElementsByClassName('live-pc')[0]) {
          document.getElementsByClassName('live-pc')[0].style.display = 'none';
        }
      } else {
        if (document.getElementsByClassName('mobile')[0]) {
          document.getElementsByClassName('mobile')[0].style.display = 'none';
        }
        if (document.getElementsByClassName('live-pc')[0]) {
          document.getElementsByClassName('live-pc')[0].style.display = 'block';
        }
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_Common_ajax__["a" /* default */].Get({
        url: userUrl + "/pc_user_online_lives?t=" + new Date().getTime(),
        headers: {
          bundle_id: 'pc',
          'bundle-id': 'pc',
          lang: 'zh-hans'
        }
      }).then(function (ref) {
        var data = ref.data;
        _this.hotOnlineList = data.online_list;
      }).catch(function (ref) {});
    }
  }
});

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bus__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Views_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Views_css_app_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Views_css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_Views_css_app_css__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_bus__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: 'zh', // 语言标识 
  messages: {
    'zh': __webpack_require__(12),
    'zh-f': __webpack_require__(13),
    'en': __webpack_require__(14)
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  i18n: i18n,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__app_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c0daea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40c0daea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c0daea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"live-pc",staticStyle:{"display":"none"}},[_c('my-header',{attrs:{"color":"#333"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"topic-top"},[_vm._v(_vm._s(_vm.$t('liveAll.content1')))]),_vm._v(" "),_c('ul',{staticClass:"topic-ul"},_vm._l((_vm.hotOnlineList.slice(0,6)),function(item,index){return _c('a',{key:index,staticClass:"pc-live-items",attrs:{"href":'/live/' + item.lgid +'.html'}},[_c('img',{attrs:{"src":item.live_pic||item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"pc-live-content"},[_c('span',[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('span',[_c('van-icon',{attrs:{"name":"user-o","color":"#a8a8a8","size":"14px"}}),_vm._v(_vm._s(item.view_num)+"\n            ")],1)])])}),0),_vm._v(" "),_c('p',{staticClass:"topic-top"},[_vm._v(_vm._s(_vm.$t('liveAll.content2')))]),_vm._v(" "),_c('ul',{staticClass:"topic-ul"},_vm._l((_vm.hotOnlineList),function(item,index){return _c('a',{key:index,staticClass:"pc-live-items",attrs:{"href":'/live/' + item.lgid +'.html'}},[_c('img',{attrs:{"src":item.live_pic||item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"pc-live-content"},[_c('span',[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('span',[_c('van-icon',{attrs:{"name":"user-o","color":"#a8a8a8","size":"14px"}}),_vm._v(_vm._s(item.view_num)+"\n            ")],1)])])}),0)]),_vm._v(" "),_c('my-footer')],1),_vm._v(" "),_c('div',{staticClass:"mobile"},[_c('h1',{staticClass:"mobile-title"},[_vm._v(_vm._s(_vm.$t('liveAll.content1')))]),_vm._v(" "),_c('ul',{staticClass:"topic-box"},_vm._l((_vm.hotOnlineList.slice(0,6)),function(item,index){return _c('li',{key:index,staticClass:"live-items"},[_c('a',{attrs:{"href":'/live/' + item.lgid + '.html'}},[_c('img',{attrs:{"src":item.live_pic||item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"live-content"},[_c('span',[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('span',[_c('van-icon',{attrs:{"name":"user-o"}}),_vm._v(_vm._s(item.view_num)+"\n            ")],1)])])])}),0),_vm._v(" "),_c('h1',{staticClass:"mobile-title"},[_vm._v(_vm._s(_vm.$t('liveAll.content2')))]),_vm._v(" "),_c('ul',{staticClass:"topic-box"},_vm._l((_vm.hotOnlineList),function(item,index){return _c('li',{key:index,staticClass:"live-items"},[_c('a',{attrs:{"href":'/live/' + item.lgid + '.html'}},[_c('img',{attrs:{"src":item.live_pic||item.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"live-content"},[_c('span',[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('span',[_c('van-icon',{attrs:{"name":"user-o"}}),_vm._v(_vm._s(item.view_num)+"\n            ")],1)])])])}),0),_vm._v(" "),_c('mobilefoot'),_vm._v(" "),_c('my-menu',{attrs:{"color":"#000"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[705]);


// WEBPACK FOOTER //
// js/live-all.b709d728c1e19fa1eb1e.js